import { Checkbox, FormControlLabel, FormHelperText, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useEffect } from "react";

const SubmissionStep = ({ props }) => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} container>
                <Grid item>
                    {props.acceptTermsError && (
                        <FormHelperText>
                            <b style={{ color: '#d32f2f' }}>{props.acceptTermsError}</b>
                        </FormHelperText>
                    )}
                </Grid>
            </Grid>
            <Grid item xs={12} container gap="10px" alignItems="center" justifyContent="space-between">
                <Grid item>
                    <FormLabel component="legend">
                        <small>
                            <strong>We accept the terms and conditions of the SPICE expert support</strong>
                        </small>
                    </FormLabel>
                </Grid>
                <Grid item>
                    <Checkbox
                        value={props.formData.terms_and_conditions}
                        checked={props.acceptTerms}
                        onChange={(e) => props.handleAcceptTermsChange(e.target.checked)}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} container>
                <Grid item>
                    {props.confirmInformationIsTrueError && (
                        <FormHelperText>
                            <b style={{ color: '#d32f2f' }}>{props.confirmInformationIsTrueError}</b>
                        </FormHelperText>
                    )}
                </Grid>
            </Grid>
            <Grid item xs={12} container gap="10px" alignItems="center" justifyContent="space-between">
                <Grid item>
                    <FormLabel component="legend">
                        <small>
                            <strong>We confirm the above information is true</strong>
                        </small>
                    </FormLabel>
                </Grid>
                <Grid item>
                    <Checkbox
                        value={props.formData.information_accuracy_confirmation}
                        checked={props.confirmInformationIsTrue}
                        onChange={(e) => props.handleConfirmInformationIsTrue(e.target.checked)}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <p>If you agree to register, any processing of provided data will comply with EU Regulations 45/2001 and 2018/1725. As the host of the registry, Radboudumc is the main data controller of this processing operation.</p>
            </Grid>
        </Grid>
    );
}

export default SubmissionStep;